import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import filter from "../../../../assests/filterIcon.svg";
import eyeIcon from "../../../../assests/eyeIcon.svg";

import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

export const CohortListComponent = (props) => {
  const [sortedData, setSortedData] = useState([]);
  const navigate = useNavigate();

 
  useEffect(() => {
    const sorted = sortDataDescending("id"); 
    setSortedData(sorted);
  }, [props.filterCohortData]);

  const sortDataDescending = (key) => {
    return [...props.filterCohortData].sort((a, b) => (a[key] < b[key] ? 1 : -1));
  };

  const handleRowClick = (id) => {
    navigate(`/home/configuration/cohortdetails/${id}`);
  };

  const createNewCohortEntery = () => {
    navigate("/home/configuration/cohort/cohortcreation");
  };

  const arrowClick = () => {
    navigate("/");
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-div">
          <div>
            <Sidebar />
          </div>
          <div style={{ width: "90vw", margin: "16px" }}>
            <div>
              <div style={{ display: "flex" }}>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={arrowClick}
                  src={leftArrow}
                  alt=""
                />
                <h2 style={{ marginLeft: "20px" }} className="userHeading">
                  Vending Machine Cohort
                </h2>
              </div>
              <div className="searchbar-sec">
                <div className="searchbaritem">
                  <input
                    type="search"
                    style={{ color: "black" }}
                    placeholder="Search by Cohort Name / Cohort Id"
                    onChange={(e) => {
                      props.Search(e.target.value);
                    }}
                  />
                  <img src={search} alt="" style={{ marginRight: "20px" }} />
                </div>
                <div>
                  <Button
                    onClick={createNewCohortEntery}
                    style={{
                      fontSize: "14px",
                      backgroundColor: "#14AE78",
                      border: "none",
                      borderRadius: "5px",
                    }}
                    variant="primary"
                    size="lg"
                  >
                    Create New Cohort
                  </Button>
                </div>
              </div>
            </div>

            <div className="scrolldown" ref={props.tableContainerRef}>
              <Table striped>
                <thead>
                  <tr style={{ border: "none" }}>
                    <th>Cohort ID</th>
                    <th>Cohort Name</th>
                    <th>Area Name</th>
                    <th>
                      <Dropdown className="cohort-type">
                        <Dropdown.Toggle
                          variant="none"
                          className="dropdown-toggle"
                          id="dropdown-basic"
                        >
                          <img
                            style={{ marginRight: "8px", marginTop: "-10px" }}
                            src={filter}
                            alt=""
                          />
                          <p style={{ color: "black", fontSize: "16px" }}>
                            Cohort Type
                          </p>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{height:"40vh", overflow:"auto"}}>
                          {props.stagecohortsTypes &&
                            props.stagecohortsTypes.map((item) => (
                              <Dropdown.Item
                                key={item.id}
                                id={item.id}
                                active={props.activeCohortType === item.id}
                                onClick={() => {
                                  console.log("Clicked on cohort type:", item.id);
                                  props.handleCohortTypeClick(item.id, item.type);
                                }}
                              >
                                {item.name}
                              </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedData &&
                    sortedData.length > 0 &&
                    sortedData.map((el) => (
                      <tr
                        key={el.id}
                        className="rowColor"
                        onClick={() => handleRowClick(el.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td style={{ textAlign: "left" }}>{el.id}</td>
                        <td style={{ textAlign: "left" }}>{el.name}</td>
                        <td style={{ textAlign: "" }}>{el.area_name}</td>
                        <td style={{ textAlign: "" }}>{el.type}</td>
                        <td className="eyeicon1">
                          <img src={eyeIcon} loading="lazy" alt="View Details" />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
